import { defineStore } from 'pinia';
import { MarketClassify } from "@/api/market.js"

// ID01：印尼 IDX 优先，美股次之，其余保持相对顺序
function sortMarketList(list = []) {
	const marketPriority = { IDX: 0, US: 1 };
	return [...list].sort((a, b) => {
		const codeA = a.code || a.param || '';
		const codeB = b.code || b.param || '';
		const pa = marketPriority[codeA] ?? 100;
		const pb = marketPriority[codeB] ?? 100;
		return pa - pb;
	});
}

export const useStockStore = defineStore('stock',{
	state: () => ({
		marketList: sortMarketList(uni.getStorageSync('marketList') || [])
	}),
	actions:{
		getMarketList(){
			return MarketClassify().then(res => {
				const list = (res.result || []).map(item => {
					return {
						...item,
						label: item.code
					}
				});
				this.marketList = sortMarketList(list);
				uni.setStorageSync('marketList', this.marketList)
			})
		}
	}
})